import React from 'react';
// template components
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import imageDesktopWebp from './images/investing-community-desktop.webp';
import imageMobileWebp from './images/investing-community-mobile.webp';

export default () => (
  <InformationalModule
    // configs
    sectionId='sustainability-impact-communities'
    moduleName='financial-planning-module'
    reverseContent={false}
    // content
    subHeadingText={<>Investing in <WidowBlock>our communities</WidowBlock></>}
    // column content
    columnContentA={(
      <>
        <Typography nextElement='button'>
          We support transformational and sustainable community outcomes that help improve lives.
        </Typography>
        <Link
          id='sustainability-impact-communities-link'
          variant='buttonLinkSecondary'
          linkUrl='/who-we-are/sustainability-impact/communities/'
          ariaLabel='Find out more about investing in communities.'>
          Find out more
        </Link>
      </>
    )}
    // image props
    imageAltText='Students holding up cards of Super Mario characters such as Peach and Yoshi'
    imageSrcDefault={imageDesktopWebp}
    imageSrcMobile={imageMobileWebp}
  />
);
